import React from "react";
import { NavDropdown } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { FaAngleDown } from "react-icons/fa";
import { Link } from "gatsby";
import styled from "styled-components";

import emiji1 from '../../../assets/images/emoji.png'
import emiji2 from '../../../assets/images/emoji-light.png'
import pymes from '../../../assets/images/pymes.png'

const DropPersona = ({ landingPage }) => {
	const NavDropdownTitle = (
		<span style={{ color: "#fff", marginRight: "20px" }}>
			<img
				src={emiji1}
				alt='Cuenta'
				placeholder='blurred'
				width={28}
				className='mr-1'
			/>
			{landingPage === "company" ? "PYMES" : "Persona"}
			<FaAngleDown />
		</span>
	);
	return (
		<Wrapper title={NavDropdownTitle} className='btn btn-primary'>
			<Link className='dropdown-item' to='/'>
				<img
					className='mr-1'
					width={22}
					src={emiji2}
					alt='emoji'
				/>
				Persona
			</Link>
			<Link className='dropdown-item' to='/company'>
				<img
					className='mr-1'
					width={22}
					src={pymes}
					alt='pymes'
				/>
				PYMES
			</Link>
		</Wrapper>
	);
};

export default DropPersona;

const Wrapper = styled(NavDropdown)`
	/* margin-top: 20px; */
	/* padding: 20px; */
	/* left: 24px; */

	border-radius: 15px;

	@media only screen and (max-width: 991px) {
		margin-top: 0;
	}
`;
